import sx from 'utils/createSx';

export const LIST_ITEM_TEXT_PRIMARY = {
  variant: 'subtitle1' as const,
  sx: { fontWeight: 600 },
};

export default sx({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    alignItems: 'stretch',
  },
  pageContainer: { py: 3 },
  pageTitle: { fontWeight: 600 },
  filtersPaper: { p: 2, borderRadius: 2, mb: 2 },
  dateRowStack: { alignItems: { xs: 'stretch', sm: 'flex-end' } },
  filterButton: { minWidth: { sm: 120 } },
  listPaper: { p: 1, borderRadius: 2, minHeight: 200 },
  paginationWrap: { display: 'flex', justifyContent: 'center', mt: 2 },
  loadingBox: { display: 'flex', justifyContent: 'center', py: 6 },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    py: 6,
    px: 2,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    textAlign: 'center',
    color: 'text.secondary',
  },
  emptyIcon: { fontSize: 48, opacity: 0.5, display: 'block', mx: 'auto' },
  emptyText: { width: '100%' },
  evolutionRowPaper: { mb: 1, borderRadius: 2, overflow: 'hidden' },
  listItemButton: { py: 1.5, px: 2 },
});
